import cn from "classnames";

import type { StatusIconVariant } from "@/components/statusIcon/statusIcon.component";

/**
 * Rendering config for rich-text feature block styles.
 * Keep keys in sync with block styles in `studio/src/schemaTypes/definitions/richText.ts`.
 */
export const FEATURE_BLOCK_STYLE_VALUES = [
  "featureIncluded",
  "featureNotIncluded",
  "featureExcluded",
  "featureThinCheck",
] as const;

export type FeatureBlockStyleValue =
  (typeof FEATURE_BLOCK_STYLE_VALUES)[number];

export type FeatureBlockStyleConfig = {
  variant: StatusIconVariant;
  strikethrough: boolean;
  srOnlyLabel: string;
};

export const FEATURE_BLOCK_STYLE_CONFIG: Record<
  FeatureBlockStyleValue,
  FeatureBlockStyleConfig
> = {
  featureIncluded: {
    variant: "check",
    strikethrough: false,
    srOnlyLabel: "Included",
  },
  featureNotIncluded: {
    variant: "close",
    strikethrough: true,
    srOnlyLabel: "Not included",
  },
  featureExcluded: {
    variant: "close",
    strikethrough: false,
    srOnlyLabel: "Not included",
  },
  featureThinCheck: {
    variant: "thinCheck",
    strikethrough: false,
    srOnlyLabel: "Benefit",
  },
};

export function getFeatureBlockTextClassName(
  config: FeatureBlockStyleConfig,
): string {
  return cn(
    "rich-text-feature-icon-text min-w-0 flex-1 max-lg:text-left!",
    config.strikethrough && "text-greyscale-strength line-through",
  );
}

export function getFeatureBlockStyleConfig(
  style: string | undefined,
): FeatureBlockStyleConfig | null {
  if (!style || !(style in FEATURE_BLOCK_STYLE_CONFIG)) {
    return null;
  }

  return FEATURE_BLOCK_STYLE_CONFIG[style as FeatureBlockStyleValue];
}

export function isFeatureBlockStyle(
  style: string | undefined,
): style is FeatureBlockStyleValue {
  return style != null && style in FEATURE_BLOCK_STYLE_CONFIG;
}
